<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
                  <stockroom-select
                    :clearable="false"
                    :val="filter.stockroom_id"
                    @change="filter.stockroom_id = $event"
                  ></stockroom-select>
                </el-form-item>
                <el-form-item label="关键字" prop="query">
                  <el-input
                    v-model="filter.query"
                    placeholder="名称或编码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="出库类型" prop="stock_out_category">
                  <el-select v-model="filter.stock_out_category">
                    <el-option
                      v-for="(value, index) in ItemStockOutCategoryMap"
                      :key="index"
                      :label="value"
                      :value="parseInt(index)"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="出库时间" prop="date">
                  <el-date-picker
                    clearable
                    v-model="filter.date"
                    type="daterange"
                    size="small"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="getData(true)">重置</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <div style="display: flex; justify-content: space-between">
            <CommodityCategoryFilter
              v-model="filter.commodity_category"
              @change="commodityCategoryChange"
            ></CommodityCategoryFilter>
            <div style="display: flex">
              <file-button
                obj="item_out_record"
                :filter="filter"
                :importButton="false"
                exportBtnName="导出"
              ></file-button>
            </div>
          </div>

          <item-table
            :items="items.list"
            :admin="admin"
            :commodityCategory="commodityCategory"
            v-loading="loading"
          ></item-table>
          <el-pagination
            background
            class="m-t-20 text-right"
            :page-size="filter.size"
            :current-page.sync="filter.page"
            @current-change="getData()"
            layout="total, prev, pager, next"
            :total="items.count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { itemOutRecordList } from '@/service/getData'
import ItemTable from './table'
import ItemOutFormer from '@/components/item_out_former'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'
import CommodityCategoryFilter from '@/components/select/commodity_category_filter.vue'
import { ItemStockOutCategoryMap } from '../../../../config/global'

export default {
  components: {
    CommodityCategoryFilter,
    ItemTable,
    ItemOutFormer,
    StockroomSelect,
  },
  data() {
    return {
      ItemStockOutCategoryMap,
      commodityCategory: {},
      loading: false,
      filter: {
        page: 1,
        size: 20,
        stockroom_id: 1,
        query: '',
        date: '',
        commodity_category: 0,
        stock_out_category: '',
      },
      admin: getStore('userInfo').is_stockroom_admin,
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
  },
  methods: {
    commodityCategoryChange(e) {
      this.commodityCategory = e
      this.filter.commodity_category = e.id
      this.filter.page = 1
      this.getData()
    },
    async getData(reset = false) {
      if (reset) {
        this.$refs['filterForm'].resetFields()
        this.filter.page = 1
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = this.clone(this.filter)
      data.page -= 1

      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      let res = await itemOutRecordList(data)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>